import { api } from '@api/api2';
import type { GetPointsPayload } from './types';

export const getList = (payload: GetPointsPayload) =>
  api.no_vers('get', 'scud/get-levels-entity', {
    ...payload,
  });
